import { NewTiming, ReadTiming } from "@app/components/Timing";
import { useQuery } from "@tanstack/react-query";

export const useTiming = () => {
	return useQuery({
		queryKey: ["timing"],
		queryFn: () => ReadTiming(),
		staleTime: 0,
		placeholderData: NewTiming(),
	});
};
